<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Demandes de service
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des demandes clients</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Card header: actions + count -->
    <div class="afri-card-header">
      <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
        <button *ngIf="buttonsPermission.add"
                (click)="add(addContent)"
                class="btn-afri-primary">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Ajouter
        </button>

        <button *ngIf="buttonsPermission.show"
                (click)="show(showContent)"
                class="btn-afri-outline">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          Consulter
        </button>

        <button *ngIf="buttonsPermission.edit"
                (click)="edit(editContent)"
                class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d;">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
          </svg>
          Éditer
        </button>

        <button *ngIf="buttonsPermission.delete"
                (click)="delete()"
                class="btn-afri-danger">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          Supprimer
        </button>
      </div>

      <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
        <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
        élément(s)
        <app-loading [isVisible]="loading2"></app-loading>
      </div>
    </div>

    <!-- Table -->
    <div style="overflow-x: auto;">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 52px; padding-left: 1.5rem;">#</th>
            <th>Client</th>
            <th>Prestataire</th>
            <th>Date demande</th>
            <th>Durée</th>
            <th>Coût</th>
            <th>Statut demande</th>
            <th>Statut paiement</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of data | paginate: {
                id: 'ngxP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total
              } | sampleSearch:search_text"
              [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">

            <td style="padding-left: 1.5rem;">
              <input (click)="checked(d)"
                     type="radio" name="selectRow"
                     style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
            </td>
            <td>
              <div style="font-weight: 600; color: #1e293b;">
                {{ d.client?.lastname }} {{ d.client?.firstname }}
              </div>
            </td>
            <td style="color: #475569;">
              {{ d.provider?.user?.lastname }} {{ d.provider?.user?.firstname }}
            </td>
            <td style="color: #475569; white-space: nowrap;">
              {{ d.date_time | date:'dd/MM/yyyy HH:mm' }}
            </td>
            <td style="color: #475569;">{{ d.duration }}</td>
            <td style="font-weight: 600; color: #2E3190;">{{ d.total_price }}</td>
            <td><app-status [value]="d.status"></app-status></td>
            <td><app-status [value]="d.payment_status"></app-status></td>
          </tr>

          <tr *ngIf="data.length === 0 && !loading2">
            <td colspan="8" style="padding: 4rem 1.25rem; text-align: center;">
              <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <p style="margin: 0; font-weight: 500;">Aucune demande trouvée</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="padding: 0.5rem 1.5rem 1.25rem;">
      <pagination-controls
        id="ngxP1"
        (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div><!-- end card -->
</div>


<!-- ─── Modal: Ajouter ─────────────────────────────────── -->
<ng-template #addContent let-c="close" let-d="dismiss">
  <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h5 class="modal-title fw-semibold d-flex align-items-center gap-2">
        <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        Ajouter un CV
      </h5>
      <button type="button" class="btn-close" (click)="d('Cross click')"></button>
    </div>

    <div class="modal-body">
      <div class="row g-3">

        <div class="col-12">
          <label class="afri-label">Profession <span class="text-danger">*</span></label>
          <input type="text" name="job_title" class="afri-input" ngModel placeholder="Ex: Développeur Web">
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Années d'expérience <span class="text-danger">*</span></label>
          <input type="number" name="experience_years" class="afri-input" ngModel min="0" placeholder="3">
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Localisation <span class="text-danger">*</span></label>
          <input type="text" name="location" class="afri-input" ngModel placeholder="Ex: Cotonou, Bénin">
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Type de contrat <span class="text-danger">*</span></label>
          <select name="contract_type" class="afri-input" ngModel>
            <option value="">— Choisir —</option>
            <option value="CDI">CDI</option>
            <option value="CDD">CDD</option>
            <option value="Freelance">Freelance</option>
          </select>
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Niveau d'études <span class="text-danger">*</span></label>
          <select name="education_level" class="afri-input" ngModel>
            <option value="">— Choisir —</option>
            <option value="Bac">Bac</option>
            <option value="Licence">Licence</option>
            <option value="Master">Master</option>
            <option value="Doctorat">Doctorat</option>
          </select>
        </div>

        <div class="col-12">
          <label class="afri-label">Visibilité <span class="text-danger">*</span></label>
          <select name="visibility" class="afri-input" ngModel>
            <option value="">— Choisir —</option>
            <option value="public">Public</option>
            <option value="payant">Payant</option>
            <option value="privé">Privé</option>
          </select>
        </div>

        <!-- Compétences -->
        <div class="col-12" style="margin-top: 0.5rem;">
          <div style="border-top: 1px solid #f1f5f9; padding-top: 1rem;">
            <label class="afri-label" style="margin-bottom: 0.625rem;">Compétences</label>
            <div class="flex gap-2">
              <input type="text" name="skill" [(ngModel)]="skill"
                     class="afri-input flex-1" placeholder="Ajouter une compétence…">
              <button type="button" (click)="addSkill()" class="btn-afri-primary" style="white-space: nowrap;">
                + Ajouter
              </button>
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: 0.75rem;" *ngIf="skills.length">
              <span *ngFor="let sk of skills; let i = index"
                    style="display: inline-flex; align-items: center; gap: 0.375rem; padding: 0.25rem 0.75rem; border-radius: 999px; font-size: 0.8125rem; font-weight: 500; background: #eff3ff; color: #2E3190; border: 1px solid #c7d2fe;">
                {{ sk }}
                <button type="button" (click)="removeSkill(i)"
                        style="display: flex; align-items: center; width: 16px; height: 16px; border-radius: 50%; border: none; background: transparent; cursor: pointer; padding: 0; color: #9ca3af;">
                  <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div class="col-12">
          <label class="afri-label">Fichier CV (PDF) <span class="text-danger">*</span></label>
          <input type="file" class="afri-input" accept=".pdf" (change)="upload($event)"
                 style="padding: 0.5rem 0.875rem;">
        </div>

      </div>
    </div>

    <div class="modal-footer">
      <button type="button" (click)="d('Cross click')" class="btn-afri-outline">Annuler</button>
      <button type="submit" class="btn-afri-primary" [disabled]="addForm.invalid">
        <svg *ngIf="!loading" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        Enregistrer
        <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>


<!-- ─── Modal: Éditer ─────────────────────────────────── -->
<ng-template #editContent let-c="close" let-d="dismiss">
  <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h5 class="modal-title fw-semibold d-flex align-items-center gap-2">
        <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
        </svg>
        Modifier le CV
      </h5>
      <button type="button" class="btn-close" (click)="d('Cross click')"></button>
    </div>

    <div class="modal-body">
      <div class="row g-3">

        <div class="col-12">
          <label class="afri-label">Profession</label>
          <input type="text" name="job_title" class="afri-input" [(ngModel)]="selected_data.job_title">
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Années d'expérience</label>
          <input type="number" name="experience_years" class="afri-input" [(ngModel)]="selected_data.experience_years">
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Localisation</label>
          <input type="text" name="location" class="afri-input" [(ngModel)]="selected_data.location">
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Type de contrat</label>
          <select name="contract_type" class="afri-input" [(ngModel)]="selected_data.contract_type">
            <option value="CDI">CDI</option>
            <option value="CDD">CDD</option>
            <option value="Freelance">Freelance</option>
          </select>
        </div>

        <div class="col-12 col-md-6">
          <label class="afri-label">Niveau d'études</label>
          <select name="education_level" class="afri-input" [(ngModel)]="selected_data.education_level">
            <option value="Bac">Bac</option>
            <option value="Licence">Licence</option>
            <option value="Master">Master</option>
            <option value="Doctorat">Doctorat</option>
          </select>
        </div>

        <div class="col-12">
          <label class="afri-label">Visibilité</label>
          <select name="visibility" class="afri-input" [(ngModel)]="selected_data.visibility">
            <option value="public">Public</option>
            <option value="payant">Payant</option>
            <option value="privé">Privé</option>
          </select>
        </div>

        <div class="col-12" style="margin-top: 0.5rem;">
          <div style="border-top: 1px solid #f1f5f9; padding-top: 1rem;">
            <label class="afri-label" style="margin-bottom: 0.625rem;">Compétences</label>
            <div class="flex gap-2">
              <input type="text" name="skill" [(ngModel)]="skill"
                     class="afri-input flex-1" placeholder="Ajouter une compétence…">
              <button type="button" (click)="addSkill()" class="btn-afri-primary" style="white-space: nowrap;">
                + Ajouter
              </button>
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-top: 0.75rem;" *ngIf="skills.length">
              <span *ngFor="let sk of skills; let i = index"
                    style="display: inline-flex; align-items: center; gap: 0.375rem; padding: 0.25rem 0.75rem; border-radius: 999px; font-size: 0.8125rem; font-weight: 500; background: #eff3ff; color: #2E3190; border: 1px solid #c7d2fe;">
                {{ sk }}
                <button type="button" (click)="removeSkill(i)"
                        style="display: flex; align-items: center; width: 16px; height: 16px; border-radius: 50%; border: none; background: transparent; cursor: pointer; padding: 0; color: #9ca3af;">
                  <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div class="col-12">
          <label class="afri-label">Nouveau CV (optionnel)</label>
          <input type="file" class="afri-input" accept=".pdf" (change)="upload($event)"
                 style="padding: 0.5rem 0.875rem;">
        </div>

      </div>
    </div>

    <div class="modal-footer">
      <button type="button" (click)="d('Cross click')" class="btn-afri-outline">Annuler</button>
      <button type="submit" class="btn-afri-primary" [disabled]="editForm.invalid">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        Sauvegarder
        <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>


<!-- ─── Modal: Consulter ──────────────────────────────── -->
<ng-template #showContent let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title fw-semibold d-flex align-items-center gap-2">
      <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
      </svg>
      Détails du CV
    </h5>
    <button type="button" class="btn-close" (click)="d('Cross click')"></button>
  </div>

  <div class="modal-body">

    <!-- Info grid -->
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.875rem; margin-bottom: 1rem;">
      <div style="background: #f8fafc; border-radius: 10px; padding: 1rem; border: 1px solid #f1f5f9;">
        <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin: 0 0 0.375rem; font-weight: 600;">Profession</p>
        <p style="font-weight: 700; color: #1e293b; margin: 0; font-size: 0.9375rem;">{{ selected_data?.job_title ?? '—' }}</p>
      </div>
      <div style="background: #f8fafc; border-radius: 10px; padding: 1rem; border: 1px solid #f1f5f9;">
        <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin: 0 0 0.375rem; font-weight: 600;">Expérience</p>
        <p style="font-weight: 700; color: #1e293b; margin: 0; font-size: 0.9375rem;">{{ selected_data?.experience_years ?? '—' }} ans</p>
      </div>
      <div style="background: #f8fafc; border-radius: 10px; padding: 1rem; border: 1px solid #f1f5f9;">
        <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin: 0 0 0.375rem; font-weight: 600;">Localisation</p>
        <p style="font-weight: 600; color: #374151; margin: 0;">{{ selected_data?.location ?? '—' }}</p>
      </div>
      <div style="background: #f8fafc; border-radius: 10px; padding: 1rem; border: 1px solid #f1f5f9;">
        <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin: 0 0 0.375rem; font-weight: 600;">Contrat</p>
        <p style="font-weight: 600; color: #374151; margin: 0;">{{ selected_data?.contract_type ?? '—' }}</p>
      </div>
      <div style="background: #f8fafc; border-radius: 10px; padding: 1rem; border: 1px solid #f1f5f9;">
        <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin: 0 0 0.375rem; font-weight: 600;">Niveau</p>
        <p style="font-weight: 600; color: #374151; margin: 0;">{{ selected_data?.education_level ?? '—' }}</p>
      </div>
      <div style="background: #f8fafc; border-radius: 10px; padding: 1rem; border: 1px solid #f1f5f9;">
        <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin: 0 0 0.375rem; font-weight: 600;">Visibilité</p>
        <app-status [value]="selected_data?.visibility"></app-status>
      </div>
    </div>

    <!-- Compétences -->
    <div *ngIf="skills?.length"
         style="background: #f8fafc; border-radius: 10px; padding: 1rem; border: 1px solid #f1f5f9;">
      <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin: 0 0 0.625rem; font-weight: 600;">Compétences</p>
      <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
        <span *ngFor="let sk of skills"
              style="padding: 0.25rem 0.75rem; border-radius: 999px; font-size: 0.8125rem; font-weight: 500; background: #eff3ff; color: #2E3190; border: 1px solid #c7d2fe;">
          {{ sk }}
        </span>
      </div>
    </div>

  </div>
</ng-template>


<!-- ─── Offcanvas: PDF Viewer ──────────────────────────── -->
<ng-template #contentPDF let-offcanvas>
  <div class="offcanvas-header" style="background: linear-gradient(135deg, #2E3190, #3a3eaa); color: white; padding: 1.25rem 1.5rem;">
    <h5 class="offcanvas-title fw-semibold" style="color: white; margin: 0;">Visualiseur de fichier</h5>
    <button id="closePDFBtn" type="button" class="btn-close"
            style="filter: invert(1);"
            (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body" style="padding: 0;">
    <ngx-extended-pdf-viewer [src]="pdfSrc" style="width: 100%; height: 100%;"></ngx-extended-pdf-viewer>
  </div>
</ng-template>
